/**
 * SH Bundle Image Swap
 * Scrolls the product gallery to the matching image when a variant is selected.
 * Works on both bundle (product set) and standard product pages.
 *
 * Listens for the theme's `variant-selected` CustomEvent on <media-gallery>
 * and at the document level (for bubbling set-product events). Matches the
 * selected variant's featured_image URL to a gallery slide and calls
 * swiper.slideTo() to scroll to it.
 */
(function () {
    'use strict';

    const product = window.eHS.product;
    if (product.product_type === "standard") return;

    var LOG_PREFIX = '[SH Bundle Image Swap]';

    /**
     * Normalize a Shopify CDN image URL for comparison.
     * Strips protocol, CDN size suffixes (_200x, _1466x1466), and query strings.
     */
    function normalizeImageUrl(url) {
        if (!url) return '';
        // Remove protocol
        url = url.replace(/^https?:/, '');
        // Remove Shopify CDN size params (e.g., _200x, _1466x, _1466x1466)
        url = url.replace(/_\d+x\d*(\.[a-z]+)/i, '$1');
        // Remove query string
        url = url.replace(/\?.*$/, '');
        return url;
    }

    /**
     * Find the gallery slide index whose <img> src matches the given image URL.
     * Returns -1 if no match is found.
     */
    function findSlideIndex(slides, imageUrl) {
        var normalized = normalizeImageUrl(imageUrl);
        for (var i = 0; i < slides.length; i++) {
            var img = slides[i].querySelector('img');
            if (!img) continue;
            if (normalizeImageUrl(img.src) === normalized) return i;
            // Also check srcset entries (first URL before the space)
            if (img.srcset) {
                var firstSrc = img.srcset.split(',')[0].trim().split(' ')[0];
                if (normalizeImageUrl(firstSrc) === normalized) return i;
            }
        }
        return -1;
    }

    /**
     * Get the Swiper instance from the carousel element.
     * Returns null if not yet initialized.
     */
    function getSwiper() {
        var el = document.querySelector('[data-product-media-carousel]');
        return el ? el.swiper || null : null;
    }

    /**
     * Scroll the gallery to the slide matching the variant's featured image.
     */
    function scrollToVariantImage(variant) {
        if (!variant) return;

        var imageUrl = variant.featured_image;
        if (!imageUrl) {
            console.log(LOG_PREFIX, 'Variant has no featured_image, skipping.');
            return;
        }

        var slides = document.querySelectorAll('[data-media-gallery-slide]');
        if (!slides.length) return;

        var index = findSlideIndex(slides, imageUrl);
        if (index === -1) {
            console.warn(LOG_PREFIX, 'No matching slide found for', imageUrl);
            return;
        }

        var swiper = getSwiper();
        if (!swiper) {
            console.warn(LOG_PREFIX, 'Swiper not initialized yet.');
            return;
        }

        swiper.slideTo(index);
        console.log(LOG_PREFIX, 'Scrolled to slide', index, 'for variant', variant.title || variant.id);
    }

    /**
     * Handle variant-selected events from the theme.
     * The event detail is the variant object with featured_image, id, sku, etc.
     */
    function onVariantSelected(e) {
        var variant = e.detail;
        if (!variant) return;
        console.log(LOG_PREFIX, 'Variant selected:', variant.title || '', '(ID:', variant.id + ')');
        scrollToVariantImage(variant);
    }

    /**
     * Initialize listeners.
     */
    function init() {
        var gallery = document.querySelector('media-gallery');
        if (!gallery) return;

        var slides = document.querySelectorAll('[data-media-gallery-slide]');
        var variants = window.eHS && product ? product.variants : [];
        console.log(LOG_PREFIX, 'Initialized.', slides.length, 'slides,', variants.length, 'variants.');

        // Listen on the gallery element (direct dispatch from theme's pr() function)
        gallery.addEventListener('variant-selected', onVariantSelected);

        // Listen at document level for bubbling events from set products (ra() dispatches with bubbles: true)
        document.addEventListener('variant-selected', onVariantSelected);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
